import Reflux from "reflux";

export default Reflux.createActions([
  "unfriend",
  "acceptFriendRequest",
  "cancelFriendRequest",
  "follow",
  "unfollow",
]);
